export const setCookie = (cookieName, cookieValue, expireTime) => {
    let expires;
    if (expireTime === "max") {
        expires = "expires=" + new Date(2147483647 * 1000).toUTCString();
    } else {
        const date = new Date();
        date.setTime(date.getTime() + expireTime);
        expires = "expires=" + date.toUTCString();
    }
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
};
export const getCookie = (cookieName) => {
    const name = cookieName + "=";
    const cookieArray = document.cookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return false;
};
export const deleteCookie = (cookieName)=>{
    document.cookie = cookieName + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
};